import { createAsyncThunk } from "@reduxjs/toolkit";
import { ROUTE_PATHS } from "../../constants/index";

export const userLogin = createAsyncThunk(
  "user/login",
  async ({ payload, history }, thunkApi) => {
    // try {
    //   const res = await loginService(payload)
    //   if (res) {
    //     thunkApi.dispatch(setServerSeedHash(res?.serverSeedHash))
    //     signIn({ token: res?.accessToken })
    //   }
    //   return res
    // } catch (error) {
    //   history.push(ROUTE_PATHS.home)
    //   return thunkApi.rejectWithValue(error[0].description)
    // }
  }
);

export const gameClose = createAsyncThunk(
  "user/game-close",
  async (data, thunkApi) => {
    // try {
    //   // const res = await gameCloseService()
    //   // if (res) {
    //     // signOut()
    //   }
    //   return res
    // } catch (error) {
    //   return thunkApi.rejectWithValue(error[0].description)
    // }
  }
);
